// extracted by css-extract-rspack-plugin
export default {"icon":"icon--v4B_HA6knGQNTAje","text":"text--gfQ8W63ONY8ttU_s"};